import { render } from "./pageLoader.vue?vue&type=template&id=17c39179&scoped=true"
const script = {}

import "./pageLoader.vue?vue&type=style&index=0&id=17c39179&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17c39179"]])

export default __exports__